import React from 'react';
//children
import NavigationList from '../../../../common/NavigationList/';

const StandaloneList = (props) => {
  const { pageJson, selectedSowProduct = {} } = props;
  let list = (selectedSowProduct.notionalPooling && selectedSowProduct.notionalPooling.poolingStructure &&
    selectedSowProduct.notionalPooling.poolingStructure.standAloneAccount) || []

  return (
    <div className="gdoc-np-pool-list-container standalone-list">
      <NavigationList
        history={props.history}
        listtype="caseBodyProductRequests"
        pageReferer="notionalPoolingStandaloneList"
        accounts={props.accounts}
        productDetailsdata={list}
        addStandaloneEvent={props.editStandaloneEvent}
        deleteStandAloneAccount={props.deleteStandAloneAccount}
        pageJson={pageJson}
        lang={props.lang}
        productType="gls-sow"
      />
    </div>
  );
}

export default StandaloneList;



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/NotionalPoolSummary/GlsNotionalPoolingStrucutre/StandaloneList.js